export const getPaginationPages = (currentPage: number, lastPage: number) =>
  lastPage <= 6
    ? Array(lastPage)
        .fill(1)
        .map((number, index) => number + index)
    : currentPage < 4
    ? [1, 2, 3, 4, '...', lastPage]
    : currentPage > lastPage - 2
    ? [1, '...', lastPage - 3, lastPage - 2, lastPage - 1, lastPage]
    : [
        1,
        '...',
        currentPage - 1,
        currentPage,
        currentPage + 1,
        '...',
        lastPage,
      ];

export const transformValue = (value: number, maxValue: number, minValue = 1) =>
  Math.min(maxValue, Math.max(minValue, value));
